import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=5c02955a&"
import script from "./CouponPage.vue?vue&type=script&lang=js&"
export * from "./CouponPage.vue?vue&type=script&lang=js&"
import style0 from "./CouponPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports